// @flow

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import R from 'ramda';
import {
  READ_PERMISSION,
  WRITE_PERMISSION,
  TEAM_ACCESS
} from '../../common/support/accessControlConstants';

const UserPermissions = new ReduxAsyncAction('USER_PERMISSIONS');
UserPermissions.registerRequest(function(isAgencyUser, isAgencyView) {
  return dash_api.get('/v1/dashboard-user/permissions').then(({ data }) => {
    // check if the agency user is not on agency dashboard and has write permission
    // and step down the permission to read only
    const stepDownAgencyTeamAccess =
      isAgencyUser &&
      !isAgencyView &&
      R.path([TEAM_ACCESS, 'permission'], data) === WRITE_PERMISSION;
    if (stepDownAgencyTeamAccess) {
      const dataPermission = R.clone(data);
      dataPermission[TEAM_ACCESS] = R.assoc(
        'permission',
        READ_PERMISSION,
        R.path([TEAM_ACCESS], dataPermission)
      );
      return dataPermission;
    }
    return data;
  });
});
export const getUserPermissions = UserPermissions.request;
export const USER_PERMISSIONS = UserPermissions.constants;

const DefaultRoles = new ReduxAsyncAction('DEFAULT_ROLES');
DefaultRoles.registerRequest(function() {
  return dash_api.get('/v1/access-control/default-roles').then(({ data }) => {
    return data.reduce((roles, rule) => {
      /* rule: {
          access_role_id: 3,
          name: 'aggregate_data',
          permission: 1,
          ...
        }*/
      const roleIdConfig = roles[rule.access_role_id]
        ? { ...roles[rule.access_role_id] }
        : {};
      roleIdConfig[rule.name] = rule.permission;

      roles[rule.access_role_id] = roleIdConfig;
      /* roles: {
          1: { ... },
          2: { ... },
          3: {
            'aggregate_data': 1,
            'link_level_settings': 0,
            ...
          },
          4: { ... }
        }*/
      return roles;
    }, {});
  });
});
export const getDefaultRoles = DefaultRoles.request;
export const DEFAULT_ROLES = DefaultRoles.constants;
